/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsListTree: {
  name: 'list-tree';
  data: string;
} = {
  name: 'list-tree',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2H7v4h3a1 1 0 1 1 0 2H7v4h8.586l-.293-.293a1 1 0 0 1 1.414-1.414l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414l.293-.293H7a2 2 0 0 1-2-2V3a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
